/* Halloween 2026 — Sale section scripts (coupon copy + HH2026 coupon sync) */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function getRoot() {
    return document.getElementById('sale');
  }

  function getDefaultCoupon(root) {
    return (root && root.getAttribute('data-default-coupon')) || 'REDRAGON15';
  }

  function getDefaultFine(root) {
    return (root && root.getAttribute('data-default-fine')) || '';
  }

  function beatTemplate(root) {
    return (
      (root && root.getAttribute('data-coupon-beat-template')) ||
      'Your coupon: [CODE] ([OFF]% off) — beats the public 15%! Use it at checkout.'
    );
  }

  function readBestCoupon() {
    var hh = window.HH2026;
    if (hh && hh.bestCoupon && hh.bestCoupon.code) {
      return hh.bestCoupon;
    }
    return null;
  }

  function applyCoupon(coupon) {
    var root = getRoot();
    if (!root) return;

    var defaultCode = getDefaultCoupon(root);
    var defaultFine = getDefaultFine(root);
    var code = coupon && coupon.code ? coupon.code : defaultCode;
    var off = coupon && coupon.off != null ? coupon.off : null;

    root.querySelectorAll('[data-hh2026-coupon-val]').forEach(function (el) {
      el.textContent = code;
    });

    root.querySelectorAll('[data-hh2026-coupon-fine]').forEach(function (el) {
      if (coupon && coupon.code && off != null) {
        el.textContent = beatTemplate(root)
          .replace(/\[CODE\]/g, coupon.code)
          .replace(/\[OFF\]/g, String(off))
          .replace(/\{\{\s*code\s*\}\}/g, coupon.code)
          .replace(/\{\{\s*off\s*\}\}/g, String(off));
      } else {
        el.textContent = defaultFine;
      }
    });

    root.querySelectorAll('[data-hh2026-price-hint]').forEach(function (el) {
      var base = el.getAttribute('data-default-hint') || el.textContent;
      if (coupon && coupon.off != null) {
        el.textContent = base + ' · your ' + coupon.off + '% beats it';
      } else {
        el.textContent = base;
      }
    });
  }

  function syncFromHH2026() {
    applyCoupon(readBestCoupon());
  }

  function wireCopy(root) {
    root.querySelectorAll('[data-hh2026-coupon-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var best = readBestCoupon();
        var code = (best && best.code) || getDefaultCoupon(root);
        var label = btn.getAttribute('data-label') || btn.textContent;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code);
        } else {
          var ta = document.createElement('textarea');
          ta.value = code;
          document.body.appendChild(ta);
          ta.select();
          try {
            document.execCommand('copy');
          } catch (e) {}
          document.body.removeChild(ta);
        }
        btn.textContent = 'COPIED ✓';
        setTimeout(function () {
          btn.textContent = label;
        }, 2000);
      });
    });
  }

  ready(function () {
    var root = getRoot();
    if (!root) return;

    wireCopy(root);
    syncFromHH2026();

    window.addEventListener('HH2026:coupon', function (e) {
      var detail = (e && e.detail) || null;
      if (detail && detail.code) {
        applyCoupon(detail);
      } else {
        syncFromHH2026();
      }
    });

    // Poll lightly in case games update window.HH2026.bestCoupon without an event
    var last = null;
    setInterval(function () {
      var c = readBestCoupon();
      var key = c ? c.code + ':' + c.off : '';
      if (key !== last) {
        last = key;
        applyCoupon(c);
      }
    }, 1500);
  });
})();
